import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  class: "InvoiceBatchCreatedNotificationModal"
}
const _hoisted_2 = { class: "InvoiceBatchCreatedNotificationModalContentBlock" }
const _hoisted_3 = { class: "InvoiceID" }
const _hoisted_4 = {
  key: 0,
  class: "InvoiceError"
}
const _hoisted_5 = { class: "ErrorText" }
const _hoisted_6 = { class: "ButtonContainer" }
const _hoisted_7 = ["download", "href"]
const _hoisted_8 = {
  key: 1,
  class: "DriverButton PrimaryButton",
  disabled: ""
}
const _hoisted_9 = {
  key: 1,
  class: "InvoiceBatchCreatedNotificationModalContentBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.modalStatusIsActive)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "InvoiceBatchCreatedNotificationModalHeaderBlock" }, [
            _createElementVNode("h3", null, "Create an invoice batch")
          ], -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "lnr-checkmark-circle SuccessIcon" }, null, -1 /* CACHED */)),
              _cache[4] || (_cache[4] = _createElementVNode("p", null, "Success! Invoice batch has been created.", -1 /* CACHED */)),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "NotificationText" }, "Invoice batch ID:", -1 /* CACHED */)),
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.invoiceBatchIdentity), 1 /* TEXT */)
              ]),
              (_ctx.invoiceBatchPartial)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("i", { class: "lnr-notification-circle ErrorIcon" }, null, -1 /* CACHED */)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.enrolmentsNotPlacedInInvoiceBatch) + " enrolment(s) could not be placed in the invoice batch. ", 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.invoiceExportAvailable)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "DriverButton PrimaryButton",
                    download: _ctx.csvExport.fileName,
                    href: _ctx.csvExport.contents,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideModal()))
                  }, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "lnr-launch ButtonIcon" }, null, -1 /* CACHED */),
                    _createTextVNode(" Export this batch ", -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_7))
                : (_openBlock(), _createElementBlock("button", _hoisted_8, [...(_cache[7] || (_cache[7] = [
                    _createElementVNode("i", { class: "lnr-sync ButtonIcon" }, null, -1 /* CACHED */),
                    _createTextVNode(" Generating export ", -1 /* CACHED */)
                  ]))])),
              _createElementVNode("button", {
                class: "ExitButton CancelButton",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hideModal()))
              }, "Close")
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_ctx.modalStatusIsFailed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[9] || (_cache[9] = [
            _createElementVNode("p", null, [
              _createElementVNode("i", { class: "lnr-notification-circle FailIcon" })
            ], -1 /* CACHED */),
            _createElementVNode("p", null, "The invoice batch was not created. None of the enrolments were changed, please try again.", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true)
  ], 512 /* NEED_PATCH */))
}